// @ts-expect-error commonMessageFormatGetters is not typed
import { getStatus } from './commonMessageFormatGetters';
import { FAILED } from '../constants/statusTypes';
export const isMessagePublished = message => {
  return getStatus(message) !== FAILED;
};